<template>
    <div class="game-info-base-wrap">
        <div class="game-info-blank-title" :style="{ backgroundColor: titleColor,color:textColor}">
         <p>{{ title }}</p>
        </div>
        <div class="game-info-blank-content" :class="cutomClass" :style="{border: useBorder ? `.02rem solid ${titleColor}` : 'none'}">
         <slot/>
        </div>
    </div> 
</template>

<script>
export default{
    props: {
        useBorder:{
            type: Boolean,
            default: true
        },
        titleColor: {
            type: String,
            default: '#fff'
        },
        textColor:{
            type: String,
            default: 'black'
        },
        title:{
            type: String,
            default: 'BIAO TI'
        },
        cutomClass:{
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss" scoped>
.game-info-base-wrap{
    display: flex;
    flex-direction: column;
    height: 100%;
    min-width: 2rem;
    box-sizing: border-box;
    
    .game-info-blank-title{
        margin-bottom: .02rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
        padding: 0 .07rem;
        p{
            font-weight: bold;
            font-size: .12rem;
        }
    }
    .game-info-blank-content{
        position: relative;
        flex: 1;
        border: .02rem solid;
    }
}
</style>